import React from 'react';

const ContentSection = (props) => {
  const getAllOptions = () => {
    return props.data.map((item, index) => 
      <div className="content-option" key={`option${index}`}>
        <p className="content-option-title">{item.title}</p>
        <p>{item.description}</p>
      </div>
    );
  }

  return (
    <div>
      <div className="content-options">
        {getAllOptions()}
      </div>
    </div>
  );
}

export default ContentSection;